import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import type { Module } from "src/system/module.types.ts";

export const module: Module = {
  id: ResourceEnum.Stock,
  name: (t: TFunction) => t("moduleName.inventory"),
  smallIcon: <i className="icon-15-inventory" />,
  bigIcon: <i className="icon-20-inventory" />,

  disableEdit: true,
  disableDelete: true,
  disableCreate: true,
};
